(function($){

    if($('table.variations').length > 0){
        if($('table.variations').css('display') != 'none'){

            $('table.variations select').on('change', function(){

                // Czekamy aż WooCommerce zaktualizuje selecty
                setTimeout(function(){

                    $('table.variations select').each(function(){
                        const $select = $(this);
                        const enabledOptions = $select.find('option').filter(function(){
                            const val = $(this).val();
                            return val !== '' && !$(this).is(':disabled');
                        });

                        if(enabledOptions.length === 1 && !$select.val()) {
                            const val = enabledOptions.first().val();
                            $select.val(val).trigger('change');
                        }
                    });

                }, 100); // 100ms wystarcza w 99% przypadków, możesz zwiększyć do 200 jeśli nie działa

            });

        }
    }

})(jQuery);
